import { DEFAULT_EVENT_TICKER, DEFAULT_HEIGHT, DEFAULT_WIDTH } from '../defaults';
import { EVENT_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

export const advancedChart: WidgetSchema = {
    meta: {
        id: 'advanced-chart',
        category: 'charts',
        categoryTitle: 'Charts',
        title: 'Chart (Large)',
        description: 'A large, interactive market chart for an event.',
        status: 'live',
    },
    fields: [
        {
            kind: 'event-search',
            key: 'eventTicker',
            label: 'Event',
            defaultValue: DEFAULT_EVENT_TICKER,
            allowManualTicker: true,
        },
        {
            kind: 'boolean',
            key: 'useMostRecentInSeries',
            label: 'Always show the most recent event in the series',
            defaultValue: false,
        },
        { kind: 'theme', key: 'colorTheme', label: 'Theme', defaultValue: 'light' },
        {
            kind: 'dimensions',
            key: 'dimensions',
            label: 'Size',
            defaultValue: { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT },
        },
        {
            kind: 'utm',
            key: 'utm',
            label: 'Marketing (UTM)',
            defaultValue: { utmSource: '', utmCampaign: '', promoCode: '' },
        },
        { kind: 'boolean', key: 'showBorder', label: 'Border', defaultValue: false },
        { kind: 'boolean', key: 'rounded', label: 'Rounded corners', defaultValue: false },
    ],
    preview: { kind: 'event-loader' },
    embed: { kind: 'event-loader', fixed: { widgetSize: 'large', period: 'all' } },
    dataSource: {
        summary: 'Every price this chart draws comes from one public endpoint: the event and its nested markets.',
        requests: EVENT_REQUESTS,
    },
};
